export default class SidePane{
	constructor(){
		this.initialize();
	}
	initialize(){
		if(window.currentContext == "sp") return;
		
		const isWedding = document.body.classList.contains("wedding");
		const stickypane = document.querySelector(".sidepane--sticky");
		if(stickypane){
			const body = document.querySelector(".column2__main");
			const isWedding = document.body.classList.contains("wedding");
			ScrollTrigger.create({
				trigger: stickypane,
				start: "top-="+(isWedding ? window.rpx(100) : 0)+" top",
				endTrigger: body,
				end: ()=>"bottom+="+(window.innerHeight - stickypane.offsetHeight - (isWedding ? window.rpx(100) : 0))+" bottom",
				pin: true,
				pinSpacing: false
			});
		}

		const navigationpane = document.querySelector(".sidepane__navigation");
		if(navigationpane){
			const items = document.querySelectorAll(".sidepane__navigation__item");
			const navi = [];
			items.forEach(item=>{
				const target = document.querySelector(item.getAttribute("href"));
				if(target){
					navi.push({
						link: item,
						target: target
					});
				}
			})
			navi.forEach(item=>{
				ScrollTrigger.create({
					trigger: item.target,
					start: "top top+="+(window.rpx(80) + (isWedding ? window.rpx(100) : 0)),
					end: "bottom top+="+(window.rpx(80) + (isWedding ? window.rpx(100) : 0)),
					onEnter: ()=>{
						navi.forEach(i=>{ i.link.classList.remove("current") });
						item.link.classList.add("current");
					},
					onEnterBack: ()=>{
						navi.forEach(i=>{ i.link.classList.remove("current") });
						item.link.classList.add("current");
					},
				});
			});
		}
	}
}